/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * EvententityKinds enum value
 */
export enum ITKSECEventEntityKinds {
    /**
     * UserEntity
     */
    User = 610000,
}
